import {SyncIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'

export interface RetryButtonProps {
  handleRetryMessage: () => void
  disabled?: boolean
}

export function RetryButton({handleRetryMessage, disabled = false}: RetryButtonProps) {
  const handleClick = () => {
    handleRetryMessage()
  }

  return (
    <IconButton
      variant="invisible"
      aria-label="Retry"
      data-testid="retry-button"
      onClick={handleClick}
      icon={SyncIcon}
      disabled={disabled}
    />
  )
}

try{ RetryButton.displayName ||= 'RetryButton' } catch {}